module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Border Lord")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reviewPage",
    attrs: {
      "id": "rev"
    }
  }, [_c('h2', {
    staticClass: "reviewPageHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Praise for Sophia James")])])]), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("High Seas to High Society")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“James weaves her spell, captivating readers with wit and wisdom, and cleverly combining humor and poignancy with a master’s touch in this feel-good love story.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Romantic Times BOOKreviews")])])])]), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Masquerading Mistress")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“Bold and tantalizing, plotted like a mystery and slowly exposing each layer of the multidimensional plot and every character’s motivations, James’ novel is a page-turner.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Romantic Times BOOKreviews")])])])]), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("Ashblane’s Lady")])])])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('span', [_vm._v("“An excellent tale of love, this book is more than a romance; it pulls at the heartstrings and makes you wish the story wouldn’t end.”")])]), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Romantic Times BOOKreviews")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b1c0eae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/borderlordthe_rev.vue
// module id = 69
// module chunks = 0